import { useState, useEffect } from "react";
import CalendarModal from "./components/DeliveryCalendarModal";
import HistoryTable from "./components/DeliveryHistoryTable";
import HistorySummary from "./components/DeliveryHistorySummary";

import { fetchManualOrders } from "./api/deliveryApi";
import EmptyStateComponent from "shared/ui/empty";
import { useMerchant } from "context/merchant";
import { useModalManager } from "shared/hooks/useModalManager";

export default function DeliveryHistoryScreen() {
  const { isFullScreen, toggleFullScreen } = useMerchant();
  const { openModal, closeModal, currentModal } = useModalManager();

  const [startDate, setStartDate] = useState(new Date());
  const [endDate, setEndDate] = useState(new Date());

  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);
  const [selectedModal, setSelectedModal] = useState("");

  const loadOrders = async () => {
    setLoading(true);
    try {
      const res = await fetchManualOrders({
        statusIds: [1],
        // startDate,
        // endDate,
        page: 1,
        limit: 1000,
      });
      if (res.success && res.data) {
        setItems(res.data);
      } else {
        setItems([]);
      }
    } catch (error) {
      console.error("Error fetching orders:", error);
      setItems([]);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    loadOrders();
  }, [startDate, endDate]);

  const isEmpty = !loading && items.length === 0;

  return (
    <div className={`container-fluid ${isFullScreen && "fullScreenText"}`}>
      <CalendarModal
        show={currentModal === "calendar"}
        handleClose={closeModal}
        refetch={loadOrders}
        selectedModal={selectedModal}
        setStartDate={setStartDate}
        setEndDate={setEndDate}
      />
      <div className="row">
        <div className="col-12">
          {isFullScreen ? (
            <div className="fab">
              <div
                className="btn btn-primary btn-lg rounded-start-0"
                onClick={toggleFullScreen}
              >
                <i className="ri ri-fullscreen-exit-line" />
              </div>
            </div>
          ) : (
            <div className="page-title-box">
              <div className="page-title-right col-4">
                <form className="d-flex justify-content-end">
                  <a
                    className="btn btn-primary ms-1"
                    onClick={toggleFullScreen}
                  >
                    <i className="ri ri-fullscreen-line" />
                  </a>
                </form>
              </div>
              <h4 className="page-title">Дуудлагын түүх</h4>
            </div>
          )}
        </div>
      </div>

      <div className="row">
        <div className="col-8">
          <div className="card">
            <div className="card-body pt-1">
              {isEmpty ? (
                <EmptyStateComponent title="Дуудлага байхгүй байна" />
              ) : (
                <HistoryTable items={items} loading={loading} />
              )}
            </div>
          </div>
        </div>

        <div className="col-4 stick">
          <HistorySummary
            startDate={startDate}
            endDate={endDate}
            items={items}
            onCalendarOpen={() => openModal("calendar")}
            loading={loading}
            setSelectedModal={setSelectedModal}
          />
        </div>
      </div>
    </div>
  );
}
